/**
 * Tilled Admin API
 *
 * Contact: integrations@tilled.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface InternalUserInvitation { 
    /**
     * The ID of the Account associated with this pending user.
     */
    account_id: string;
    /**
     * Time at which the object was created.
     */
    created_at: string;
    /**
     * The pending user\'s email.
     */
    email: string;
    /**
     * Time at which the object will expire.
     */
    expires_at: string;
    /**
     * Unique identifier for the object.
     */
    id: string;
    /**
     * Frontend link for the user invitation.
     */
    invitation_url?: string;
    /**
     * The ID of the user who sent the invitation.
     */
    inviter_user_id?: string;
    /**
     * The pending user\'s role, primarily used in the Tilled Dashboard. The roles have varied restrictions on the actions they can take.
     */
    role: InternalUserInvitation.RoleEnum;
    /**
     * Time at which the invitation was last sent.
     */
    sent_at?: string;
    /**
     * Time at which the object was last updated.
     */
    updated_at: string;
}
export namespace InternalUserInvitation {
    export type RoleEnum = 'owner' | 'admin' | 'developer' | 'analyst' | 'view_only' | 'account_manager' | 'restricted_view_only' | 'onboarding_sales_rep' | 'reseller_owner' | 'reseller_admin' | 'reseller_view_only' | 'reseller_sales_rep' | 'reseller_support_specialist' | 'reseller_integration_analyst' | 'merchant_owner' | 'merchant_admin' | 'merchant_view_only';
    export const RoleEnum = {
        OWNER: 'owner' as RoleEnum,
        ADMIN: 'admin' as RoleEnum,
        DEVELOPER: 'developer' as RoleEnum,
        ANALYST: 'analyst' as RoleEnum,
        VIEW_ONLY: 'view_only' as RoleEnum,
        ACCOUNT_MANAGER: 'account_manager' as RoleEnum,
        RESTRICTED_VIEW_ONLY: 'restricted_view_only' as RoleEnum,
        ONBOARDING_SALES_REP: 'onboarding_sales_rep' as RoleEnum,
        RESELLER_OWNER: 'reseller_owner' as RoleEnum,
        RESELLER_ADMIN: 'reseller_admin' as RoleEnum,
        RESELLER_VIEW_ONLY: 'reseller_view_only' as RoleEnum,
        RESELLER_SALES_REP: 'reseller_sales_rep' as RoleEnum,
        RESELLER_SUPPORT_SPECIALIST: 'reseller_support_specialist' as RoleEnum,
        RESELLER_INTEGRATION_ANALYST: 'reseller_integration_analyst' as RoleEnum,
        MERCHANT_OWNER: 'merchant_owner' as RoleEnum,
        MERCHANT_ADMIN: 'merchant_admin' as RoleEnum,
        MERCHANT_VIEW_ONLY: 'merchant_view_only' as RoleEnum
    };
}


